import { defineRouting } from 'next-intl/routing';

/**
 * Shared routing configuration used by middleware and the navigation APIs defined with the defineRouting function
 * See https://next-intl.dev/docs/routing/routing for available options
 */
export const routing = defineRouting({
  locales: ['en-GB', 'en-US', 'nl-NL'], // When adding a locale: update`validSiteLocales` in src/utils/datoHelpers.vitest.test.ts
  defaultLocale: 'en-GB',
  localePrefix: 'as-needed',
  localeDetection: false,
  localeCookie: false,
  // locale-aware hreflang (alternate links) emitted explicitly  via buildAlternates()
  alternateLinks: false
});
